






























































import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import KelasAutoComplete from "@/components/KelasAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    UnitAutoComplete,
    KelasAutoComplete,
  },
})
export default class ModalLogin extends Vue {
  @Prop() readonly value!: boolean;
  // @Prop() item!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*Alasan harus diisi"];
  // msg = "";
  // unit = {};
  // kelas = {};
  // no = null;
  private username = "";
  private pass = "";
  // private username = "1974011920120410160";
  // private pass = "19740119";
  private error = false;
  private text = "";
  // unitSelected = this.unit;
  id = "";
  nama = "";
  valid = true;
  validationError = {};
  timeout = 2000;
  showEyeIcon = false;
  // host = window.location.host;
  host = "localhost";

  async login() {
    // alert("login");
    try {
      await userModule.signIn({
        username: this.username,
        password: this.pass,
        // unit: this.unitSelected["nama"],
        // unit_id: this.unitSelected["id"],
        // zona: this.unitSelected["zona"],
      });
      // console.log("siukses");

      storeBed.actClearBed();
      this.$router.push("info-admin");
    } catch (err) {
      console.log("gagal");
      this.error = true;
      this.validationError = err["text"].message;
    }
  }
  // setUnit(val) {
  //   this.unit = val;
  // }
  // setKelas(val) {
  //   this.kelas = val;
  // }

  close() {
    this.username = "";
    this.pass = "";
    // this.no = null;
    this.show = false;
  }

  // message() {
  //   return this.msg;
  // }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
